import config from 'configDir/index';
import { get } from './http';

const baseUrl = '/organization';

// 获取组织架构树
const getArchitectureTreeService = get(
  `${baseUrl}/getArchitectureTree`,
  config.userCenterServiceUrl,
);
const queryTreeService = get(`${baseUrl}/queryTree`, config.userCenterServiceUrl);

export { getArchitectureTreeService, queryTreeService };
